import React from 'react';
import styled, { css } from 'styled-components';
import { CrunchBerryHover } from '../styles';
import { analyticsTrackEvent } from '../../../core/analytics';
import { HEADER_DIRECTORY_LINKS_LINK_CLICK } from '~/core/analytics/events';
import { Link } from '../links';

const StyledLink = styled.a.withConfig({ componentId: 'sc-z0kmgy-0' })<{ sc: { padding?: string } }>`
  display: block;
  ${({ sc }) => css`
    padding: ${sc.padding || '12px 0'};
  `};
`;

type LinkItemProps = {
  link: Link;
  category: string;
  subcategory?: string;
  padding?: string;
};

const LinkItem = ({ link, category, subcategory, padding }: LinkItemProps) => (
  <StyledLink
    href={link.url}
    onClick={() =>
      analyticsTrackEvent(HEADER_DIRECTORY_LINKS_LINK_CLICK, {
        linkUrl: link.url,
        linkCategory: category,
        linkSubcategory: subcategory,
        label: link.label,
      })
    }
    sc={{ padding }}
  >
    <CrunchBerryHover>{link.label}</CrunchBerryHover>
  </StyledLink>
);

export default LinkItem;
